import { useState, useEffect } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useSelector } from "react-redux";
import { format } from "rut.js";

import { datetimeToLocale, integerValidate } from "@/services/Utils";

import classes from "./createOrder.module.scss";
import { useOrderCreate } from "@/hooks/purchases/orders";
import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";
import InputExchange from "@/components/Form/Exchange/InputExchange";
import CustomDateInput from "@/components/desktop/form/input/input-date/CustomDateInput";

const CreateOrderHead = ({ params, data, setData }) => {
	const { data: response } = useOrderCreate(params);
	const { business, estates_parents, estates, types_currency, petitioners } = response;

	const { customer } = useSelector((state) => state.auth.user);

	const [activeDetail, setActiveDetail] = useState(true);
	const [dealers, setDealers] = useState([]);
	const [classifications, setClassifications] = useState([]);

	useEffect(() => {
		if (response) {
			setDealers(response.dealers);
			setClassifications(response.classifications);
		}
	}, [response]);

	const handleChangeDealer = (opt) => {
		const dealer = dealers.find((d) => d.value === opt.value);

		if (!dealer) {
			let newDealers = [...dealers];
			const newDealer = {
				value: opt.value,
				label: opt.value,
			};

			newDealers.push(newDealer);
			setDealers(newDealers);
		}

		setData({
			...data,
			dealer_id: opt.value,
			rut_dealer: dealer ? dealer.rut_dealer : "",
		});
	};

	const handleChangeClassification = (opt) => {
		const exist = classifications.find((d) => d.value === opt.value);

		if (!exist) {
			let newClassifications = [...classifications];
			const newClassification = {
				value: opt.value,
				label: opt.value,
			};

			newClassifications.push(newClassification);
			setClassifications(newClassifications);
		}

		setData({
			...data,
			classification_id: opt.value,
		});
	};

	const selectEstateParent = estates_parents.find((e) => String(e.value) === String(data.estate_parent_id));
	const selectEstate = estates.find((e) => String(e.value) === String(data.estate_id));
	const selectDealer = dealers.find((d) => String(d.value) === String(data.dealer_id));

	return (
		<Col md={12} className={classes.col_base}>
			<Card className={activeDetail && "active"}>
				<Card.Header onClick={() => setActiveDetail(!activeDetail)} className={activeDetail && "active"}>
					Detalle
					<div>
						{!!customer.use_estates_parents && (
							<span style={{ marginRight: "1em" }}>
								<strong>
									{customer.customer_screens.find((cs) => cs.screen_id === 38)
										? customer.customer_screens.find((cs) => cs.screen_id === 38)?.name
										: "Grupo Campo"}
									:
								</strong>
								{` ${selectEstateParent ? selectEstateParent.label : ""}`}
							</span>
						)}
						<span style={{ marginRight: "1em" }}>
							<strong>
								{customer.customer_screens.find((cs) => cs.screen_id === 51)
									? customer.customer_screens.find((cs) => cs.screen_id === 51)?.name
									: "Campo"}
								:
							</strong>
							{` ${selectEstate ? selectEstate.label : ""}`}
						</span>
						<span style={{ marginRight: "1em" }}>
							<strong> Distribuidor:</strong>
							{` ${selectDealer ? selectDealer.label : ""}`}
						</span>
						<span>
							<strong> N° OC:</strong>
							{` ${data.code_oc ? data.code_oc : ""}`}
						</span>
					</div>
				</Card.Header>
				{activeDetail && (
					<Card.Body>
						<Row className={classes.header}>
							<Col md={6} sm={12} className={classes.headerLeft}>
								<div className={classes.divInput}>
									<div className={classes.inputForm}>
										<div className={classes.inputText}>Razón Social</div>
										<div>
											<Select
												value={business && business.filter((b) => Number(b.value) === Number(data.business_id))}
												placeholder={<div>Seleccione</div>}
												options={business}
												onChange={(value) =>
													setData({
														...data,
														business_id: value.value,
													})
												}
											/>
										</div>
									</div>

									{!!customer.use_estates_parents && (
										<div className={classes.inputForm}>
											<div className={classes.inputText}>
												{customer.customer_screens.find((cs) => cs.screen_id === 38)
													? customer.customer_screens.find((cs) => cs.screen_id === 38)?.name
													: "Grupo Campo"}
											</div>
											<div>
												<Select
													value={estates_parents && estates_parents.filter((b) => Number(b.value) === Number(data.estate_parent_id))}
													placeholder={<div>Seleccione</div>}
													options={estates_parents}
													onChange={(value) =>
														setData({
															...data,
															estate_parent_id: value ? value.value : "",
															estate_id: "",
														})
													}
													isClearable={true}
												/>
											</div>
										</div>
									)}

									<div className={classes.inputForm}>
										<div className={classes.inputText}>
											{customer.customer_screens.find((cs) => cs.screen_id === 51)
												? customer.customer_screens.find((cs) => cs.screen_id === 51)?.name
												: "Campo"}
										</div>
										<div>
											<Select
												value={estates && estates.filter((b) => String(b.value) === String(data.estate_id))}
												placeholder={<div>Seleccione</div>}
												options={
													data.estate_parent_id
														? estates.filter((e) => String(e.estate_parent_id) === String(data.estate_parent_id))
														: estates
												}
												onChange={(value) =>
													setData({
														...data,
														estate_id: value ? value.value : "",
														estate_parent_id: value ? value.estate_parent_id : data.estate_parent_id ? data.estate_parent_id : "",
													})
												}
												isClearable={true}
											/>
										</div>
									</div>

									<Row>
										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Distribuidor</div>
												<div>
													<CreatableSelect
														value={dealers && dealers.filter((d) => d.value === data.dealer_id)}
														options={dealers}
														formatCreateLabel={(value) => {
															return `Crear ${value}`;
														}}
														components={{
															NoOptionsMessage,
														}}
														placeholder={""}
														onChange={(opt, _meta) => handleChangeDealer(opt)}
													/>
												</div>
											</div>
										</Col>

										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>RUT</div>
												<div>
													<Form.Control
														style={{
															padding: "6px",
														}}
														onChange={(e) =>
															setData({
																...data,
																rut_dealer: e.target.value,
															})
														}
														type="text"
														value={data.rut_dealer ? format(data.rut_dealer) : ""}
													/>
												</div>
											</div>
										</Col>
									</Row>

									{!customer.use_estates_parents && (
										<div className={classes.inputForm}>
											<div className={classes.inputText}>Observaciones</div>
											<div>
												<Form.Control
													style={{
														padding: "6px",
													}}
													onChange={(e) =>
														setData({
															...data,
															observations: e.target.value,
														})
													}
													as="textarea"
													rows={3}
													value={data.observations ? data.observations : ""}
												/>
											</div>
										</div>
									)}
								</div>
							</Col>

							<Col md={6} sm={12} className={classes.headerRight}>
								<div className={classes.divInput}>
									<Row>
										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Número OC</div>
												<div>
													<Form.Control
														style={{
															padding: "6px",
														}}
														onChange={(e) =>
															setData({
																...data,
																code_oc: e.target.value,
															})
														}
														type="text"
														onKeyDown={integerValidate}
														value={data.code_oc ? data.code_oc : ""}
													/>
												</div>
											</div>
										</Col>

										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Solicitado por</div>
												<div>
													<Select
														value={petitioners && petitioners.filter((b) => Number(b.value) === Number(data.petitioner_id))}
														placeholder={<div>Seleccione</div>}
														options={petitioners}
														onChange={(value) =>
															setData({
																...data,
																petitioner_id: value.value,
															})
														}
													/>
												</div>
											</div>
										</Col>
									</Row>

									<Row>
										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Clasificación</div>
												<div>
													<CreatableSelect
														value={
															classifications && classifications.filter((d) => String(d.value) === String(data.classification_id))
														}
														options={classifications}
														formatCreateLabel={(value) => {
															return `Crear ${value}`;
														}}
														components={{
															NoOptionsMessage,
														}}
														placeholder={<div>Seleccione</div>}
														onChange={(opt, _meta) => handleChangeClassification(opt)}
													/>
												</div>
											</div>
										</Col>

										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Contacto</div>
												<div>
													<Form.Control
														style={{
															padding: "6px",
														}}
														onChange={(e) =>
															setData({
																...data,
																contact: e.target.value,
															})
														}
														type="text"
														value={data.contact ? data.contact : ""}
													/>
												</div>
											</div>
										</Col>
									</Row>

									<Row>
										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Fecha Ingreso</div>
												<div>
													<CustomDateInput
														value={data && data.date_create_order}
														setValue={(index, value) => {
															setData({
																...data,
																date_create_order: value,
															});
														}}
													/>
												</div>
											</div>
										</Col>

										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Fecha Entrega</div>
												<div>
													<CustomDateInput
														value={data && data.date_order}
														setValue={(index, value) => {
															setData({
																...data,
																date_order: value,
																date_calculate: value,
																exchange_rate_type: "order",
															});
														}}
													/>
												</div>
											</div>
										</Col>
									</Row>

									<Row>
										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Moneda</div>
												<div>
													<Select
														value={
															types_currency && types_currency.filter((b) => Number(b.value) === Number(data.type_currency_id))
														}
														placeholder={<div>Seleccione</div>}
														options={types_currency}
														onChange={(value) =>
															setData({
																...data,
																type_currency_id: value.value,
															})
														}
													/>
												</div>
											</div>
										</Col>

										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Tipo de Cambio</div>

												<InputExchange data={data} setData={setData} />
											</div>
										</Col>
									</Row>

									<Row>
										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>
													{data && data.approver && "Aprobador"}
													{data && data.rejecter && "Rechazador"}
												</div>
												<div>
													{data && data.approver && data.approver}
													{data && data.rejecter && data.rejecter}
												</div>
											</div>
										</Col>

										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>
													{data && data.date_approved && "Fecha Aprobación"}
													{data && data.date_reject && "Fecha Rechazo"}
												</div>
												<div>
													{data && data.date_approved && datetimeToLocale(data.date_approved)}
													{data && data.date_reject && datetimeToLocale(data.date_reject)}
												</div>
											</div>
										</Col>
									</Row>

									{!!customer.use_estates_parents && (
										<div className={classes.inputForm}>
											<div className={classes.inputText}>Observaciones</div>
											<div>
												<Form.Control
													style={{
														padding: "6px",
													}}
													onChange={(e) =>
														setData({
															...data,
															observations: e.target.value,
														})
													}
													as="textarea"
													rows={3}
													value={data.observations ? data.observations : ""}
												/>
											</div>
										</div>
									)}
								</div>
							</Col>
						</Row>
					</Card.Body>
				)}
			</Card>
		</Col>
	);
};

export default CreateOrderHead;
